module.exports = __webpack_public_path__ + "static/media/Thumbs.dc03fa77.db";